import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "creditLimitManagement",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.CREDIT_LIMIT_MANAGEMENT.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.CREDIT_LIMIT_MANAGEMENT.PERMISSIONS,
    },
    component: () =>
      import("@/modules/CreditLimitManagement/views/CreditLimitRequests.vue"),
  },
  {
    path: PATH.CREATE_CREDIT_LIMIT_REQUEST,
    name: "createCreditLimitRequest",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.CREATE_CREDIT_LIMIT_REQUEST.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.CREATE_CREDIT_LIMIT_REQUEST.PERMISSIONS,
    },
    component: () =>
      import("@/modules/CreditLimitManagement/views/CreateCreditLimitRequest.vue"),
  },
  {
    path: PATH.CREDIT_LIMIT_REQUEST_DETAIL,
    name: "creditLimitRequestDetail",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.CREDIT_LIMIT_REQUEST_DETAIL.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.CREDIT_LIMIT_REQUEST_DETAIL.PERMISSIONS,
    },
    component: () =>
      import("@/modules/CreditLimitManagement/views/CreditLimitRequestDetail.vue"),
  },
];

export default routes;
